import { render, staticRenderFns } from "./VButtonPageBack.vue?vue&type=template&id=7df33ffa&"
import script from "./VButtonPageBack.vue?vue&type=script&lang=js&"
export * from "./VButtonPageBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports